import { render } from "./DocsTreeNode.vue?vue&type=template&id=5bf4c3b3&scoped=true"
import script from "./DocsTreeNode.vue?vue&type=script&lang=js"
export * from "./DocsTreeNode.vue?vue&type=script&lang=js"

import "./DocsTreeNode.vue?vue&type=style&index=0&id=5bf4c3b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4c3b3"]])

export default __exports__